import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { checkIsMobileApp } from "bridge/common/CommonBridge";
import { XAPI_CODE, xAPI_PATH } from "utils/xAPI_PATH";
import { setIA } from "store/modules/common/xapiReducer";
import _ from "lodash";
import { consoleLog } from "utils/dictUtil";
import { getXAPIPath } from "utils/localStorage";

const useXAPI = () => {
    const dispatch = useDispatch();

    const loginInfo = useSelector((state) => state.loginReducer);
    const IAInfo = useSelector((state) => state.xapiReducer.IA);

    const isMobileApp = checkIsMobileApp();
    const envState = String(process.env.REACT_APP_ENV).trim() || "local";

    let xAPI_URL;

    const { ID_NAME_CODES, ACTIVITIES, VERBS } = XAPI_CODE || {};

    if (envState === "real") {
        xAPI_URL = "https://xapi-collector.wjtb.kr/xapi/putRecord";
    } else {
        xAPI_URL = "https://dev-xapi-collector.wjtb.kr/xapi/putRecord";
    }

    // actor
    const SERVICVE_ID = "svc_0014_0200_0000000011";
    let MMBR_CODE = String(loginInfo.mmbrSeq) || "NA";

    // object
    /**
     * 진입 경로(path)는 훅이 호출된 렌더 시점이 아니라 **이벤트를 보내는 시점**에 읽어야 한다.
     * 상수로 한 번만 읽으면, 화면 진입 후 setXAPIPath 로 갱신된 값이 반영되지 않아
     * 홈에서 누른 이벤트가 직전 경로(서랍 "L" 등)로 전송된다.
     */
    const getObjectPath = () => getXAPIPath();
    let XOBJECT_ID = "";
    let XOBJECT_IDNAME = "";
    let XOBJECT_IDVALUE = "";

    // verb
    let VERB = "";

    // serviceInfo
    let APP_VERSION = localStorage.getItem("APP_VERSION") || "1.0.0";
    let APP_PACKAGE_ID = localStorage.getItem("APP_PACKAGE_ID") || "safari";

    // envInfo
    let OS_TYPE = localStorage.getItem("OS_TYPE") || "IOS";
    let DEVICE_TYPE = isMobileApp ? "TB" : "PC";
    let PROGRAM_TYPE = "WEB";

    // contentInfo
    let CONTENT_INFO_OBJ = {};

    const sendXAPI = () => {
        const xAPI = window.xAPI;

        if (!xAPI) {
            alert("xAPI 모듈을 찾을 수 없습니다!");
            return;
        }

        // CONTENT_INFO_OBJ 값 변경 처리
        for (const key in CONTENT_INFO_OBJ) {
            if (_.isNull(CONTENT_INFO_OBJ[key]) || _.isUndefined(CONTENT_INFO_OBJ[key])) {
                // 값이 없는 경우
                CONTENT_INFO_OBJ[key] = "";
            } else if (_.isNumber(CONTENT_INFO_OBJ[key])) {
                // 숫자인 경우
                CONTENT_INFO_OBJ[key] = String(CONTENT_INFO_OBJ[key]);
            }
        }

        // [LOG]: local, dev 로그확인
        if (String(process.env.REACT_APP_ENV).trim() !== "real") {
            // consoleLog("xAPI 호출 정보", {
            //     XOBJECT_IDVALUE,
            //     XOBJECT_ID,
            //     XOBJECT_IDNAME,
            //     VERB,
            //     CONTENT_INFO_OBJ,
            // });
        }

        xAPI.sendData(
            xAPI_URL,
            new xAPI.xAPIObject(
                xAPI.Actor.builder(SERVICVE_ID, MMBR_CODE, "NA").build(),
                xAPI.XObject.builder(XOBJECT_ID, XOBJECT_IDNAME, XOBJECT_IDVALUE).build(),
                xAPI.Verb.builder(VERB).build(),
                xAPI.Context.builder(APP_PACKAGE_ID, APP_VERSION)
                    .envInfo({
                        osType: OS_TYPE,
                        deviceType: DEVICE_TYPE,
                        programType: PROGRAM_TYPE,
                    })
                    .contentInfo(CONTENT_INFO_OBJ)
                    .build(),
            ),
        );

        CONTENT_INFO_OBJ = {};
    };

    const findValueByKeyValue = (keyValue) => {
        const emptyResult = {
            gnb: "",
            lnbNm1: "",
            lnbCd1: "",
        };

        for (const key in xAPI_PATH) {
            if (key.includes(keyValue)) {
                return xAPI_PATH[key];
            }
        }

        return emptyResult;
    };

    function findLnbMenu(menuObj, keyValue) {
        for (let key in menuObj) {
            if (key.includes(keyValue)) {
                return menuObj[key];
            }
        }
        return null;
    }

    const ServiceUnit_A = (objectIdValue, menuUrl, menuCode = null) => {
        XOBJECT_IDVALUE = objectIdValue;

        XOBJECT_ID = ACTIVITIES.SERVICE_UNIT; // 서비스 객체
        XOBJECT_IDNAME = ID_NAME_CODES.BUTTON_CODE; // 버튼/메뉴 선택
        VERB = VERBS.SELECTED;

        if (menuCode) {
            CONTENT_INFO_OBJ = findValueByKeyValue(menuCode);

            if (CONTENT_INFO_OBJ.gnb !== "") {
                sendXAPI();
                return;
            }
        }

        if (menuUrl) {
            CONTENT_INFO_OBJ = findValueByKeyValue(menuUrl);
            sendXAPI();
            return;
        }

        sendXAPI();
    };

    // serviceUnit | 기본
    function ServiceUnit_B(objectIdValue = null) {
        const verbs = [VERBS.SELECTED];
        let content_info_obj = {};

        const setProperties = (verbIndex) => {
            objectIdValue || console.log("[ ServiceUnit_B > IS Empty XOBJECT_IDVALUE ] :: ", objectIdValue);
            if (!objectIdValue) return null;

            XOBJECT_IDVALUE = objectIdValue;
            XOBJECT_ID = ACTIVITIES.SERVICE_UNIT; // 서비스 객체;
            XOBJECT_IDNAME = ID_NAME_CODES.BUTTON_CODE; // 버튼/메뉴 선택
            VERB = verbs[verbIndex];
            CONTENT_INFO_OBJ = content_info_obj;

            sendXAPI();
        };

        const setContent = ({ extraContent = {} }) => {
            // path 는 screen(진입) 이벤트에만 싣는다. serviceUnit(선택)에는 gnb/lnb 등 IA 문맥만 유지하고 path 는 제외.
            const { path, ...iaWithoutPath } = IAInfo;

            content_info_obj = { ...iaWithoutPath, ...extraContent };
            return returnParam;
        };
        const selected = () => setProperties(0);

        const returnParam = {
            selected, // 선택했다
            setContent,
        };

        return returnParam;
    }

    function ServiceMessage(objectIdValue = null) {
        let content_info_obj = {};

        const showed = () => {
            if (!objectIdValue) return null;

            XOBJECT_IDVALUE = objectIdValue;
            XOBJECT_ID = ACTIVITIES.SERVICE_MESSAGE;
            XOBJECT_IDNAME = ID_NAME_CODES.SERVICE_MESSAGE_CODE;
            VERB = VERBS.SHOWED;
            CONTENT_INFO_OBJ = content_info_obj;

            sendXAPI();
        };
        const setContent = ({ extraContent = {} }) => {
            const objectPath = getObjectPath();
            const newPath = IAInfo.path !== objectPath ? objectPath : IAInfo.path;

            content_info_obj = { ...IAInfo, path: newPath, ...extraContent };
            return returnParam;
        };
        const returnParam = { showed, setContent };

        return returnParam;
    }

    // serviceUnit | 강의 > 영상
    function ServiceUnit_C(objectIdValue = null) {
        const verbs = [VERBS.SELECTED];
        let content_info_obj = {};

        const setProperties = (verbIndex) => {
            objectIdValue || console.log("[ ServiceUnit_C > IS Empty XOBJECT_IDVALUE ] :: ", objectIdValue);
            if (!objectIdValue) return null;

            XOBJECT_IDVALUE = objectIdValue;
            XOBJECT_ID = ACTIVITIES.SERVICE_UNIT; // 서비스 객체;
            XOBJECT_IDNAME = ID_NAME_CODES.BUTTON_CODE; // 버튼/메뉴 선택
            VERB = verbs[verbIndex];
            CONTENT_INFO_OBJ = content_info_obj;

            sendXAPI();
        };

        const setContent = (content) => {
            content_info_obj = content;
            return returnParam;
        };
        const selected = () => setProperties(0);

        const returnParam = {
            selected, // 선택했다
            setContent,
        };

        return returnParam;
    }

    // Screen | 화면
    function Screen() {
        const verbs = [VERBS.OPENED];
        let content_info_obj = {};

        const setProperties = (verbIndex) => {
            XOBJECT_IDVALUE = "scr_0000_0000";
            XOBJECT_ID = ACTIVITIES.SCREEN; // 화면;
            XOBJECT_IDNAME = ID_NAME_CODES.SCREEN_CODE; // 화면 진입
            VERB = verbs[verbIndex];
            CONTENT_INFO_OBJ = content_info_obj;

            sendXAPI();
        };

        const setContent = ({ IAContent, extraContent = null }) => {
            const objectPath = getObjectPath();

            content_info_obj = { ...IAContent, path: objectPath, ...extraContent };
            dispatch(setIA({ ...IAContent, path: objectPath }));
            return returnParam;
        };

        const opened = () => setProperties(0);

        const returnParam = {
            opened, // 진입했다
            setContent, // set 상세수집정보
        };

        return returnParam;
    }

    // viewPort | 메인
    function ViewPort(objectIdValue = null) {
        const verbs = [VERBS.FOCUSED];
        let content_info_obj = {};

        const setProperties = (verbIndex) => {
            objectIdValue || console.log("[ ViewPort > IS Empty XOBJECT_IDVALUE ] :: ", objectIdValue);
            if (!objectIdValue) return null;

            XOBJECT_IDVALUE = objectIdValue;
            XOBJECT_ID = ACTIVITIES.VIEWPORT; // 노출영역
            XOBJECT_IDNAME = ID_NAME_CODES.AREA_CODE; // 영역 진입
            VERB = verbs[verbIndex];
            CONTENT_INFO_OBJ = content_info_obj;

            sendXAPI();
        };

        const setContent = (content) => {
            content_info_obj = content;
            return returnParam;
        };
        const focused = () => setProperties(0);

        const returnParam = {
            focused, // 활성화되었다
            setContent, // set 상세수집정보
        };

        return returnParam;
    }

    // learningContent | 강의 학습
    function LearningContent(objectIdValue = null) {
        const verbs = [VERBS.INITIALIZED, VERBS.COMPLETED, VERBS.TERMINATED];
        let content_info_obj = {};

        const setProperties = (verbIndex) => {
            objectIdValue || console.log("[ LearningContent > IS Empty XOBJECT_IDVALUE ] :: ", objectIdValue);
            if (!objectIdValue) return null;

            XOBJECT_IDVALUE = objectIdValue;
            XOBJECT_ID = ACTIVITIES.LEARNING_CONTENT; // 노출영역
            XOBJECT_IDNAME = ID_NAME_CODES.AREA_CODE; // 영역 진입
            VERB = verbs[verbIndex];
            CONTENT_INFO_OBJ = content_info_obj;

            sendXAPI();
        };

        const setContent = (content) => {
            content_info_obj = content;
            return returnParam;
        };
        const initialized = () => {
            setProperties(0);
            return returnParam;
        };
        const completed = () => {
            setProperties(1);
            return returnParam;
        };
        const terminated = () => setProperties(2);

        const returnParam = {
            initialized, // 시작했다
            completed, // 완료했다
            terminated, // 이탈했다
            setContent, // set 상세수집정보
        };

        return returnParam;
    }

    // Assessment | 평가, 영어 VOCA
    function Assessment(objectIdValue = null) {
        const verbs = [VERBS.INITIALIZED, VERBS.COMPLETED, VERBS.TERMINATED];
        let content_info_obj = {};

        const setProperties = (verbIndex) => {
            objectIdValue || console.log("[ Assessment > IS Empty XOBJECT_IDVALUE ] :: ", objectIdValue);
            if (!objectIdValue) return null;

            XOBJECT_IDVALUE = objectIdValue;
            XOBJECT_ID = ACTIVITIES.ASSESSMENT; // 노출영역
            XOBJECT_IDNAME = ID_NAME_CODES.AREA_CODE; // 영역 진입
            VERB = verbs[verbIndex];

            CONTENT_INFO_OBJ = content_info_obj;
            sendXAPI();
        };

        const setContent = (content) => {
            content_info_obj = content;
            return returnParam;
        };
        const initialized = () => {
            setProperties(0);
            return returnParam;
        };
        const completed = () => {
            setProperties(1);
            return returnParam;
        };
        const terminated = () => setProperties(2);

        const returnParam = {
            initialized, // 시작했다
            completed, // 완료했다
            terminated, // 이탈했다
            setContent, // set 상세수집정보
        };

        return returnParam;
    }

    // Question | 문항
    function Question(objectIdValue = null) {
        const verbs = [VERBS.OPENED, VERBS.ANSWERED];
        let content_info_obj = {};

        const setProperties = (verbIndex) => {
            objectIdValue || console.log("[ Question > IS Empty XOBJECT_IDVALUE ] :: ", objectIdValue);
            if (!objectIdValue) return null;

            XOBJECT_IDVALUE = objectIdValue;
            XOBJECT_ID = ACTIVITIES.QUESTION; // 노출영역
            XOBJECT_IDNAME = ID_NAME_CODES.AREA_CODE; // 영역 진입
            VERB = verbs[verbIndex];

            CONTENT_INFO_OBJ = content_info_obj;
            sendXAPI();
        };

        const setContent = (content) => {
            content_info_obj = content;
            return returnParam;
        };
        const opened = () => {
            setProperties(0);
            return returnParam;
        };
        const answered = () => setProperties(1);

        const returnParam = {
            opened, // 진입했다
            answered, // 제출했다
            setContent, // set 상세수집정보
        };

        return returnParam;
    }

    // Explanation | 해설
    function Explanation(objectIdValue = null) {
        const verbs = [VERBS.OPENED];
        let content_info_obj = {};

        const setProperties = (verbIndex) => {
            objectIdValue || console.log("[ Explanation > IS Empty XOBJECT_IDVALUE ] :: ", objectIdValue);
            if (!objectIdValue) return null;

            XOBJECT_IDVALUE = objectIdValue;
            XOBJECT_ID = ACTIVITIES.EXPLANATION; // 노출영역
            XOBJECT_IDNAME = ID_NAME_CODES.AREA_CODE; // 영역 진입
            VERB = verbs[verbIndex];

            CONTENT_INFO_OBJ = content_info_obj;
            sendXAPI();
        };

        const setContent = (content) => {
            content_info_obj = content;
            return returnParam;
        };
        const opened = () => setProperties(0);

        const returnParam = {
            opened, // 진입했다
            setContent, // set 상세수집정보
        };

        return returnParam;
    }

    // Video | 영상
    function Video(objectIdValue = null) {
        const verbs = [VERBS.INITIALIZED, VERBS.PLAYED, VERBS.PAUSED, VERBS.SEEKED, VERBS.COMPLETED, VERBS.TERMINATED];
        let content_info_obj = {};

        const setProperties = (verbIndex) => {
            objectIdValue || console.log("[ Video > IS Empty XOBJECT_IDVALUE ] :: ", objectIdValue);
            if (!objectIdValue) return null;

            XOBJECT_IDVALUE = objectIdValue;
            XOBJECT_ID = ACTIVITIES.VIDEO; // 노출영역
            XOBJECT_IDNAME = ID_NAME_CODES.AREA_CODE; // 영역 진입

            VERB = verbs[verbIndex];

            CONTENT_INFO_OBJ = content_info_obj;
            sendXAPI();
        };

        const setContent = (content) => {
            content_info_obj = content;
            return returnParam;
        };
        const initialized = () => {
            setProperties(0);
            return returnParam;
        };
        const played = () => {
            setProperties(1);
            return returnParam;
        };
        const paused = () => {
            setProperties(2);
            return returnParam;
        };
        const seeked = () => {
            setProperties(3);
            return returnParam;
        };
        const completed = () => {
            setProperties(4);
            return returnParam;
        };
        const terminated = () => setProperties(5);

        const returnParam = {
            initialized, // 진입했다(=시작했다)
            played, // 재생을 시작했다
            paused, // 일시중지했다
            seeked, // 재생시점을 이동했다
            completed, // 완료했다
            terminated, // 이탈했다
            setContent, // set 상세수집정보
        };

        return returnParam;
    }

    return {
        ServiceUnit_A,
        ServiceUnit_B,
        ServiceUnit_C,
        ServiceMessage,
        Screen,
        ViewPort,
        LearningContent,
        Assessment,
        Question,
        Explanation,
        Video,
        findValueByKeyValue,
    };
};

export default useXAPI;
